<template>
	<span :data-toggle="label.length > 12 ? 'tooltip': ''" :title="label">{{ label }}</span>
</template>

<script>

import { Fragment } from 'vue-fragment'

export default {
	name: 'LabelTooltip',
	props: [
		'label'
	],
	components: {
		Fragment
	},
}
</script>

<style scoped>

</style>
